<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header">
              <h4 class="card-title">Store</h4>           
            </div>
            {{stores.length}}
        
            <data-tables-server
              class="table-shopping"
              style="width: 100%"
              :data="stores"
              :tool-bar="false"
              :total="total"
              :page-size="2"
              :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
            >
              <el-table-column min-width="50" label="Name" prop="name">
                <template slot-scope="props">
                  <span>{{props.row.name}}</span>
                </template>
              </el-table-column>
              <el-table-column min-width="50" label="Domain" prop="domain">
                <template slot-scope="props">
                  <span>{{props.row.domain}} </span>
                </template>
              </el-table-column>
                            <el-table-column min-width="50" label="Currency" prop="domain">
                <template slot-scope="props">
                  <span>{{props.row.currency_code}} </span>
                </template>
              </el-table-column>
               <el-table-column min-width="50" label="Products" prop="domain">
                <template slot-scope="props">
                    <span> <router-link :to="'/mailchimp/ecommerce/store/'+props.row.id">Edit</router-link></span>
                </template>
              </el-table-column>
 
            </data-tables-server>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import api from "./api";
export default {
  data() {
    return {
        stores:[],
  
      total: 0
    };
  },
  methods: {
    getStores() {
      api
        .getStores()
        .then(response => {
          this.stores= response.data.stores;
          this.total = response.data.total_items
        });
    }
   
  },

  async mounted() {
   
    this.getStores();
  }
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/Mailchimp/Store.vue